import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { blue800, green900, orange700, red800 } from '../styles/palette';
import { useThemeColor } from '../Theme';
import { useTranslate } from '../util';
import { ArrowLeftIcon, CheckmarkInCircleIcon, ExclamationInTriangleIcon, ExclamationInTriangleStatusIcon, IInCircleIcon, LockClosedIcon, PlusIcon, XIcon } from './baseIcons';
export function AlertIcon(props) {
  var t = useTranslate();
  return /*#__PURE__*/React.createElement(ExclamationInTriangleIcon, _extends({}, props, {
    color: red800,
    alt: t('citrix-ui:svg.AlertIcon')
  }));
}
export function WarningIcon(props) {
  var t = useTranslate();
  return /*#__PURE__*/React.createElement(ExclamationInTriangleIcon, _extends({}, props, {
    color: orange700,
    alt: t('citrix-ui:svg.WarningIcon')
  }));
}
export function InfoIcon(props) {
  var t = useTranslate();
  return /*#__PURE__*/React.createElement(IInCircleIcon, _extends({}, props, {
    color: blue800,
    alt: t('citrix-ui:svg.InfoIcon')
  }));
}
export function SuccessIcon(props) {
  var t = useTranslate();
  return /*#__PURE__*/React.createElement(CheckmarkInCircleIcon, _extends({}, props, {
    color: green900,
    alt: t('citrix-ui:svg.SuccessIcon')
  }));
}
export function CloseIcon(props) {
  return /*#__PURE__*/React.createElement(XIcon, _extends({}, props, {
    color: useThemeColor('secondaryActionIcon')
  }));
}
export function MobileBackIcon(props) {
  return /*#__PURE__*/React.createElement(ArrowLeftIcon, _extends({}, props, {
    color: useThemeColor('secondaryActionIcon')
  }));
}
export function AddIcon(props) {
  return /*#__PURE__*/React.createElement(PlusIcon, _extends({}, props, {
    color: "#fff"
  }));
}
export function EncryptedEmailIcon(props) {
  return /*#__PURE__*/React.createElement(LockClosedIcon, _extends({}, props, {
    color: blue800
  }));
}
export function AlertStatusIcon(props) {
  return /*#__PURE__*/React.createElement(ExclamationInTriangleStatusIcon, _extends({}, props, {
    color: red800
  }));
}